import { useSelector } from "react-redux";
import HtmlContent from "./HtmlContent";

const ACTIONS = {
    pancyr: { type: 'switchPage', payload: 1 },
    definitions: { type: 'switchPage', payload: 4 },
};

// Keys correspond to window.__APP_HTML entries populated by
// /public/content/language_help_<lang>.js.
const CONTENT_KEYS = {
    ru: 'language_help_ru',
    en: 'language_help_en',
};

const LanguageHelp = () => {
    const rus = useSelector(state => state.rus);
    const lang = rus ? 'ru' : 'en';

    return <HtmlContent contentKey={CONTENT_KEYS[lang]} actions={ACTIONS} />;
};

export default LanguageHelp;
